import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.groups = this.el.querySelectorAll('.serviceGroup')
    this.btns = this.el.querySelectorAll('.serviceBtn')

    this.setHeight()
    this.initEventlisteners()
  }

  initEventlisteners() {
    this.groups.forEach((group, index) => {
      group.addEventListener('click', this.openGroup.bind(this, group, index))
    })

    window.addEventListener('resize', this.setHeight.bind(this))
  }

  setHeight() {
    this.groups.forEach((group) => {
      const content = group.querySelector('.serviceContent')
      group.style.setProperty('--service-height', `${content.scrollHeight}px`)
    })
  }

  openGroup(group, index) {
    this.groups.forEach((g, i) => {
      if (i !== index) {
        g.classList.remove('--open')
        this.btns[i].classList.remove('--active')
      }
    })
    group.classList.toggle('--open')
    this.btns[index].classList.toggle('--active')
  }
}
